import { TagLayout } from '@app/common/settings-components/types';

export const TAG_LAYOUT_AI_DESCRIPTION = `
        The layout type for the tags.
        Possible values:
        - ${TagLayout.Button} Each tag is presented as a button.
        - ${TagLayout.Text} Each tag is presented as text.
        `;
